"use strict";

export default {
    account:{},
    authorizeData: {},
    financialAccountData: {},
    isFetchingPreScreenReport: false,
    financialInstitutionReport: {},
    isFetchingFinancialInstitutionReport: false,
    termsOfServiceData: {},
    isEditingAuthorize: false,
    isEditingTermsOfService: false,
    termsOfServiceVersion: 3,
    isCreatingEcheck: false,
    currentStep: 0,
    isFetchingEchecks: false,
    authorizedEchecks: [],
    isValid: {
        step1: false,
        step2: false,
        step3: false,
    },
    errors: {
        createEcheck:'',
    },
};
